module.exports = __webpack_public_path__ + "static/media/img_stp_card_visa.782a8692.png";